import React from 'react';
import Head from 'next/head';
import { shape } from 'prop-types';
var MetaNoIndex = function MetaNoIndex(_ref) {
  var data = _ref.data;
  var sensitiveTerm = data == null ? void 0 : data.sensitiveTerm;
  var shouldSetNoIndex = sensitiveTerm && sensitiveTerm.setNoIndex === true ? 'noindex' : 'index';
  return React.createElement(Head, null, React.createElement("meta", {
    "data-testid": "meta-no-index",
    name: "robots",
    content: shouldSetNoIndex
  }));
};
MetaNoIndex.displayName = 'MetaNoIndex';
MetaNoIndex.defaultProps = {
  data: {}
};
process.env.NODE_ENV !== "production" ? MetaNoIndex.propTypes = {
  data: shape({})
} : void 0;
MetaNoIndex.ssr = true;
export default MetaNoIndex;